<template>
    <div :style="`direction:${lang.dir}`">
        <v-form
            ref="crmForInv"
            lazy-validation
        >
        <b-sidebar backdrop lazy width="100rem" id="customer_crm" aria-labelledby="sidebar-no-header-title" no-header :style="`direction:`+lang.ldir" right>
            <template #default="{ hide }">
                <div class="m-1 text-start" style="direction:rtl">
                    <div style="width:120px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                            <span>{{lang.view_customer}}</span>
                    </div>
                    <div @click="hide" id="HideMeCRM" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                        <span>{{lang.close}}</span>
                    </div>
                </div>
                <v-divider></v-divider>
                <div class="myBtn backBlack" :style="`direction:${lang.dir}`" v-if="$store.state.licenseType.activemenu != 'smallif' || $store.state.group_id != 3">
                    <v-row>
                        <v-col cols="12" md="12">
                            <div style="background:#000;color:#FFF;border-radius:5px">
                                {{ lang.customer_information }}
                            </div>  
                            <b-simple-table>
                                <thead>
                                    <tr>
                                        <th class="text-center backBlack">{{ lang.customer_name }}</th>
                                        <th class="text-center backBlack">{{ lang.customer_name }}</th>
                                    </tr>
                                </thead>
                            </b-simple-table>
                        </v-col>
                    </v-row>

                </div>
            </template>
        </b-sidebar>
        </v-form>
    </div>
</template>


<script>
import axios from 'axios';
export default {
    data() {
        return {
            id: 0,
            customerInfo: {},
            customerDeals: []
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
    },
    methods: {
        getCustomerInfo() 
        {
            const post = new FormData();
            post.append("type", "getClientCRMInfo");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[id]", this.id);
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                const res = response.data;
                this.customerInfo = res.results.customerInfo;
                this.customerDeals = res.results.data;
            });
        },
        getCheckup() 
        {
            return false;
        },

    }
}
</script>